import { formatLocalePhoneNumber, formatPhoneNumber } from "@/utils/formatUtils";
import { AutoComplete, Form } from "antd";
import { DefaultOptionType } from "antd/es/select";
import { AutoCompleteProps } from "antd/lib/auto-complete";
import { FormItemProps } from "antd/lib/form";
import { isValidPhoneNumber } from "libphonenumber-js";
import { ContactType } from "../../../enums";
import { Contact } from "../../../types";

interface Props {
  formItemProps: FormItemProps;
  autocompleteProps?: AutoCompleteProps<string, PhoneNumberOption>;
  contacts?: Contact[];
}

interface PhoneNumberOption extends DefaultOptionType {
  valueInInternationalFormat: string;
  valueInNationalFormat: string;
}

const phoneNumberFilterFunction = (input: string, option?: PhoneNumberOption) => {
  if (!option) {
    return false;
  }

  return option.valueInInternationalFormat.indexOf(input) !== -1 || option.valueInNationalFormat.indexOf(input) !== -1;
};

export const ContactsPhoneNumberAutoComplete = ({ formItemProps, autocompleteProps, contacts }: Props) => (
  <Form.Item {...formItemProps}>
    <AutoComplete<string, PhoneNumberOption>
      {...autocompleteProps}
      popupMatchSelectWidth={false}
      options={
        contacts &&
        [
          ...new Set(
            contacts
              .filter(
                (c) =>
                  (c.type === ContactType.PHONE_NUMBER || c.type === ContactType.MAIN_PHONE_NUMBER) &&
                  isValidPhoneNumber(c.value, "SK"),
              )
              .map((c) => formatPhoneNumber(c.value)),
          ),
        ].map((phoneNumber) => ({
          value: phoneNumber,
          label: phoneNumber,
          valueInInternationalFormat: phoneNumber,
          valueInNationalFormat: formatLocalePhoneNumber(phoneNumber),
        }))
      }
      showSearch={{ filterOption: phoneNumberFilterFunction }}
    />
  </Form.Item>
);
